module.exports = __webpack_public_path__ + "static/media/preview.cfc025a5.svg";